function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.31356 0.479015C7.8422 -0.00800596 7.06531 -0.0207028 6.57829 0.450656L1.63425 5.23569C1.60037 5.26848 1.57562 5.30942 1.56231 5.35459L0.884868 7.65359C0.857013 7.74785 0.88209 7.84969 0.950398 7.92037C1.01881 7.99095 1.11977 8.01934 1.21489 7.99469L3.53481 7.39263C3.58039 7.3808 3.62211 7.3574 3.65599 7.32461L8.59992 2.53947C9.0862 2.06778 9.09889 1.29153 8.62828 0.804201L8.31356 0.479015ZM2.22547 5.42264L6.27178 1.50635L7.53478 2.81131L3.48836 6.7276L2.22547 5.42264ZM1.96058 5.9331L2.96962 6.97577L1.54426 7.34571L1.96058 5.9331ZM8.22066 2.1476L7.92676 2.43205L6.66365 1.12697L6.95766 0.842526C7.22818 0.580707 7.65976 0.58776 7.92158 0.85828L8.23641 1.18347C8.4978 1.4543 8.49075 1.88556 8.22066 2.1476Z",
  fill: "#A5B1E0"
});

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.a74af196.svg";
export { ForwardRef as ReactComponent };